var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHintOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.142A9.97 9.97 0 0022.001 12 9.97 9.97 0 0019 4.857v3.265A7.955 7.955 0 0120.001 12c0 1.407-.363 2.729-1.001 3.878v3.264z",
    fill: "#FF9F19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 12a8 8 0 11-.062-1h2.013C21.45 5.948 17.186 2 12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10h-2z",
    fill: "#FF9F19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.001 6v8h-2V6h2zM13.001 18.001v-2h-2v2h2z",
    fill: "#FF9F19"
  })));
}

export default SvgHintOutline;